const CROSSFADE_DURATION = 0.25;
const SWIPE_THRESHOLD = 40; // px

class ProductCarousel99 extends HTMLElement {
  connectedCallback() {
    this.images = Array.from(this.querySelectorAll('.card-99__image'));
    this.dots = Array.from(this.querySelectorAll('.card-99__nav-dot'));
    this.activeIndex = 0;

    if (this.images.length <= 1) return;

    this.isDesktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.showSlide(i);
      });
    });

    const mediaLink = this.querySelector('.card-99__media-link');
    if (mediaLink) {
      if (this.isDesktop) {
        // Desktop: hover advances to the second image, click always goes to product page
        mediaLink.addEventListener('mouseenter', () => this.showSlide(1));
        mediaLink.addEventListener('mouseleave', () => this.showSlide(0));
      } else {
        // Touch: a tap navigates to the product page (native link behavior,
        // untouched); a swipe advances/reverses the slide and suppresses navigation.
        // Touching also previews the second image, same as desktop hover, and
        // resets back to the first image if the touch turns out to be a tap.
        mediaLink.addEventListener('click', (event) => {
          if (this.didSwipe) {
            event.preventDefault();
            this.didSwipe = false;
          }
          // Otherwise: genuine tap, let the link navigate normally.
        });

        mediaLink.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
        mediaLink.addEventListener('touchmove', this.onTouchMove.bind(this), { passive: true });
        mediaLink.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
        mediaLink.addEventListener('touchcancel', () => this.showSlide(0), { passive: true });
      }
    }
  }

  disconnectedCallback() {
    // no-op: hover/touch no longer run a timer
  }

  onTouchStart(event) {
    this.touchStartX = event.touches[0].clientX;
    this.touchStartY = event.touches[0].clientY;
    this.isTrackingSwipe = true;
    this.didSwipe = false;
    this.showSlide(1); // preview second image on touch, same as desktop hover
  }

  onTouchMove(event) {
    if (!this.isTrackingSwipe) return;
    const dx = Math.abs(event.touches[0].clientX - this.touchStartX);
    const dy = Math.abs(event.touches[0].clientY - this.touchStartY);
    // Mostly-vertical gesture -> let the page scroll, stop tracking as a swipe
    if (dy > dx) this.isTrackingSwipe = false;
  }

  onTouchEnd(event) {
    if (!this.isTrackingSwipe) {
      this.showSlide(0); // vertical scroll or already-cancelled: reset preview
      return;
    }
    this.isTrackingSwipe = false;

    const endX = event.changedTouches[0].clientX;
    const deltaX = endX - this.touchStartX;

    if (Math.abs(deltaX) < SWIPE_THRESHOLD) {
      this.showSlide(0); // just a tap: reset preview before nav fires
      return;
    }

    this.didSwipe = true;

    if (deltaX < 0) {
      this.showSlide(this.activeIndex + 1); // swiped left -> next
    } else {
      this.showSlide(this.activeIndex - 1); // swiped right -> prev
    }
  }

  showSlide(index) {
    const total = this.images.length;
    const wrappedIndex = (index + total) % total;
    const current = this.images[this.activeIndex];
    const next = this.images[wrappedIndex];
    if (!next || next === current) return;

    gsap.to(current, { opacity: 0, duration: CROSSFADE_DURATION, ease: 'power1.out' });
    gsap.fromTo(next, { opacity: 0 }, { opacity: 1, duration: CROSSFADE_DURATION, ease: 'power1.out' });

    current.classList.remove('is-active');
    next.classList.add('is-active');

    if (this.dots.length) {
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === wrappedIndex));
    }

    this.activeIndex = wrappedIndex;
  }
}

customElements.define('product-carousel-99', ProductCarousel99);